@for(team of teams; track $index){
    @if($index < 3){
        <span class="badge text-bg-light m-1 me-1">{{team}}</span>
    }                         
}
@if(teams.length > 3){
    @if(!showAllTeams){
        <span class="text-link" (click)="showAllTeams = true" >
            <small>{{teams.length - 3}} {{'polls_settings.show_more' | translate}}</small>
        </span>
    }@else{
        @for(team of teams; track $index){
            @if($index >= 3){
                    <span class="badge text-bg-light m-1 me-3">{{team}}</span>
            }                         
        }
        <div class="text-link text-center" (click)="showAllTeams = false">
            <small><i class="fa-solid fa-chevron-up pe-1"></i>{{'polls_settings.show_less' | translate}}</small>
        </div>
    }
}